(function () {
  const MOODBOARD_PATH = '/pages/droomslaapkamer-ontwerpen';

  function normaliseTags(tags) {
    if (Array.isArray(tags)) return tags.map(String).map(tag => tag.trim().toLowerCase());
    return String(tags || '').split(',').map(tag => tag.trim().toLowerCase()).filter(Boolean);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>\"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function addStyles() {
    if (document.getElementById('bbAiMoodboardBridgeStyles')) return;
    const style = document.createElement('style');
    style.id = 'bbAiMoodboardBridgeStyles';
    style.textContent = [
      '.bb-ai-bedroom-cta-host{position:relative}',
      '.bb-ai-bedroom-cta{position:absolute;left:16px;bottom:16px;z-index:7;margin:0;max-width:calc(100% - 32px)}',
      '.bb-ai-bedroom-cta__link{display:inline-flex;align-items:center;justify-content:center;gap:7px;box-sizing:border-box;min-height:36px;padding:8px 12px;border:1px solid rgba(24,34,56,.24);border-radius:999px;background:rgba(255,255,255,.92);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);color:#182238;font-size:12px;font-weight:700;line-height:1.2;text-align:center;text-decoration:none;box-shadow:0 2px 10px rgba(15,23,42,.08);transition:transform .18s ease,background .18s ease,border-color .18s ease}',
      '.bb-ai-bedroom-cta__link:hover{background:#fff;border-color:rgba(24,34,56,.42);color:#182238;transform:translateY(-1px)}',
      '.bb-ai-bedroom-cta__link svg{width:15px;height:15px;flex:0 0 auto}',
      '@media(max-width:767px){.bb-ai-bedroom-cta{left:10px;bottom:10px;max-width:calc(100% - 20px)}.bb-ai-bedroom-cta__link{min-height:34px;padding:7px 10px;font-size:11px}.bb-ai-bedroom-cta__link svg{width:14px;height:14px}}',
      '.bbm-preselected-bed{margin:0 0 14px;padding:12px 14px;border:1px solid #dce7df;border-radius:10px;background:#f3f8f4;font-size:14px;line-height:1.4;color:#1e2524}',
      '.bbm-preselected-bed strong{font-weight:700}'
    ].join('');
    document.head.appendChild(style);
  }

  async function fetchProduct(handle) {
    const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Product kon niet worden geladen');
    return response.json();
  }

  function productHandleFromPath() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  async function initProductCta() {
    const handle = productHandleFromPath();
    if (!handle || document.querySelector('.bb-ai-bedroom-cta')) return;

    try {
      const product = await fetchProduct(handle);
      const tags = normaliseTags(product.tags);
      if (!tags.includes('bedden')) return;

      addStyles();

      const mediaHost =
        document.querySelector('.product-detail__media .media-main-swiper .swiper-wrapper-preview') ||
        document.querySelector('.product-detail__media .media-main-swiper');
      const fallbackInfo = document.querySelector('.product-detail__information') || document.querySelector('.main-product');
      const host = mediaHost || fallbackInfo;
      if (!host) return;

      if (mediaHost) mediaHost.classList.add('bb-ai-bedroom-cta-host');

      const url = new URL(MOODBOARD_PATH, window.location.origin);
      url.searchParams.set('bed', product.handle || handle);

      const wrap = document.createElement('div');
      wrap.className = 'bb-ai-bedroom-cta';
      wrap.innerHTML = '<a class="bb-ai-bedroom-cta__link" href="' + escapeHtml(url.pathname + url.search) + '">' +
        '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
        '<span>Bekijk dit bed in jouw droomslaapkamer</span></a>';

      if (mediaHost) {
        host.appendChild(wrap);
      } else {
        const target =
          host.querySelector('.product_detail-des') ||
          host.querySelector('.product-detail__short-description') ||
          host.querySelector('.product-detail__price') ||
          host.querySelector('.product-detail__title');
        if (!target) return;
        wrap.style.position = 'static';
        wrap.style.marginBottom = '20px';
        target.insertAdjacentElement('afterend', wrap);
      }
    } catch (_) {
      // De gewone productpagina blijft ongewijzigd als productdata niet beschikbaar is.
    }
  }

  function showPreselectedNotice(root, product) {
    addStyles();
    let notice = root.querySelector('#bbmPreselectedBed');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'bbmPreselectedBed';
      notice.className = 'bbm-preselected-bed';
      const filters = root.querySelector('.bbm-filters');
      if (filters && filters.parentNode) {
        filters.parentNode.insertBefore(notice, filters);
      }
    }
    notice.innerHTML = '<strong>' + escapeHtml(product.title) + '</strong> is alvast voor je geselecteerd ✓';
    notice.hidden = false;
    return notice;
  }

  async function initMoodboardPrefill() {
    const root = document.querySelector('.bb-moodboard');
    if (!root) return;

    const handle = new URLSearchParams(window.location.search).get('bed');
    if (!handle) return;

    try {
      const product = await fetchProduct(handle);
      const productId = String(product.id || '');
      if (!productId) return;

      const picker = root.querySelector('[data-picker="bed"]');
      if (!picker) return;

      let finished = false;
      let notice = null;
      const selectRequestedBed = function () {
        if (finished) return;
        const card = picker.querySelector('.bbm-card[data-id="' + productId + '"]');
        if (!card) return;

        if (card.getAttribute('aria-pressed') !== 'true') card.click();
        notice = showPreselectedNotice(root, product);
        finished = true;
      };

      const observer = new MutationObserver(selectRequestedBed);
      observer.observe(picker, { childList: true, subtree: true });
      selectRequestedBed();

      picker.addEventListener('click', function (event) {
        const card = event.target.closest('.bbm-card[data-id]');
        if (!card || !notice) return;
        if (card.dataset.id !== productId) notice.hidden = true;
      });

      window.setTimeout(function () {
        observer.disconnect();
      }, 15000);
    } catch (_) {
      // Als het product niet gevonden wordt, blijft stap 1 gewoon handmatig te gebruiken.
    }
  }

  function init() {
    initProductCta();
    initMoodboardPrefill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
